// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadDocumentFileRequestModel from '../../model/download-document-file-request-model';
import DownloadDocumentFileRequestDTO from '../dto/download-document-file-request-dto';
import dtoSchema from '../schemas/download-document-file-request-schema';

export default abstract class DownloadDocumentFileRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadDocumentFileRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<DownloadDocumentFileRequestDTO>): DownloadDocumentFileRequestModel;
  static toModel(dto: DeepPartial<DownloadDocumentFileRequestDTO> | undefined | null): DownloadDocumentFileRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadDocumentFileRequestDTO> | undefined | null): DownloadDocumentFileRequestModel | undefined {
    return dto ? new DownloadDocumentFileRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadDocumentFileRequestModel> | DownloadDocumentFileRequestModel): DownloadDocumentFileRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as DownloadDocumentFileRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DownloadDocumentFileRequestModel, can not map to DownloadDocumentFileRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
